import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CSVType } from '../../../models/csv-types';

@Component({
  selector: 'app-dialog-csv',
  templateUrl: './dialog-csv.component.html',
  styleUrls: ['./dialog-csv.component.scss']
})
export class DialogCsvComponent {

  constructor(
    private readonly dialogRef: MatDialogRef<DialogCsvComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CSVType
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }
}
